/* unplugin-vue-components disabled */import script from "./category-dialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./category-dialog.vue?vue&type=script&setup=true&lang=ts"

import "./category-dialog.vue?vue&type=style&index=0&id=53b684b2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53b684b2"]])

export default __exports__